import React, { useState, useEffect } from "react";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import dayjs from "dayjs";
import { useI18n, getLang } from "../../../i18n";
import "./Calendar.css?v=100";

const CustomCalendar = ({ value, onChange, onMonthChange, ...props }) => {
  const { t, dir } = useI18n();
  /* ★★ F1 — חצי-הניווט מתהפכים עם הכיווניות. ב-RTL "הקודם" מצביע ימינה,
     ב-LTR הוא מצביע שמאלה. ⚠️ אלה **רכיבי-אייקון**, לא CSS — הם אינם עוברים
     דרך `stylis-plugin-rtl` ולכן לא היו מתהפכים מעצמם, והחודש-הקודם ברוסית
     היה מסומן בחץ שמצביע לכיוון ההפוך. */
  const PrevIcon = dir === 'rtl' ? ChevronRightRoundedIcon : ChevronLeftRoundedIcon;
  const NextIcon = dir === 'rtl' ? ChevronLeftRoundedIcon : ChevronRightRoundedIcon;
  // Use value as the selectedDate. This turns it into a controlled component.
  const [selectedDate, setSelectedDate] = useState(value || dayjs());

  // Whenever the parent passes a new value, update internal state.
  useEffect(() => {
    if (value && !selectedDate.isSame(value, "day")) {
      setSelectedDate(value);
    }
  }, [value, selectedDate]);

  const handlePrevMonth = () => {
    const newDate = selectedDate.subtract(1, "month");
    setSelectedDate(newDate);
    onMonthChange && onMonthChange(newDate);
  };

  const handleNextMonth = () => {
    const newDate = selectedDate.add(1, "month");
    setSelectedDate(newDate);
    onMonthChange && onMonthChange(newDate);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    onChange && onChange(newDate);
  };

  const isCurrentMonth = selectedDate.isSame(dayjs(), "month");

  return (
    <Box className="custom-calendar">
      <Box className="cal-nav">
        <IconButton
          className="nav-button prev"
          disabled={isCurrentMonth}
          onClick={handlePrevMonth}
          aria-label={t("calendarNav.prevMonth")}
        >
          <PrevIcon />
        </IconButton>
        <Typography className="cal-month">
          {/* ★ F1 — היה `.locale("he")` קשיח, ולכן שם-החודש נשאר עברי בכל
              שפה. ‏`getLang()` מחזיר את קוד-השפה הנוכחי, שהוא גם קוד-ה-locale
              של dayjs (ראה `i18n/config.js`). */}
          {selectedDate.locale(getLang()).format("MMMM YYYY")}
        </Typography>
        <IconButton
          className="nav-button next"
          onClick={handleNextMonth}
          aria-label={t("calendarNav.nextMonth")}
        >
          <NextIcon />
        </IconButton>
      </Box>

      {/* showDaysOutsideCurrentMonth=false → show ONLY the current month's days. The spillover days
          from the next month were rendered but never availability-checked/coloured, so they looked
          clickable but weren't usable. */}
      <DateCalendar
        value={selectedDate}
        onChange={handleDateChange}
        showDaysOutsideCurrentMonth={false}
        reduceAnimations
        {...props}
      />
    </Box>
  );
};

export default CustomCalendar;
